/**
 * FeWo·Monitor Wortmarke — konsistent mit dem Onepager-Branding
 * (Blau #1e3a8a, Akzent-Punkt Amber #f59e0b). Größe über `className` (z. B. text-2xl).
 */
export default function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`font-extrabold select-none whitespace-nowrap ${className}`} style={{ color: '#1e3a8a' }}>
      FeWo<span style={{ color: '#f59e0b' }}>·</span>Monitor
    </span>
  );
}
